import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconBack"><Path d="M18.0618 4.13538C18.8928 3.58721 20 4.18326 20 5.17884V18.8213C20 19.8169 18.8928 20.413 18.0618 19.8648L7.71987 13.0436C6.97086 12.5495 6.97086 11.4507 7.71987 10.9566L18.0618 4.13538Z" fill="currentColor"/><Path d="M4 4.75009C4 4.33588 4.33579 4.00009 4.75 4.00009C5.16421 4.00009 5.5 4.33588 5.5 4.75009V19.2501C5.5 19.6643 5.16421 20.0001 4.75 20.0001C4.33579 20.0001 4 19.6643 4 19.2501V4.75009Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBack;
